const _ = require('lodash');
const { loadZendeskChat } = require("./utils");

function boot(profile, options = {}) {
    const enabled = _.get(profile, 'chat_enabled', false);
    if (enabled) {
        loadZendeskChat(profile, options)
    }
}

module.exports = {
    boot,
};
